import Img from '../img';
import { BackToTopButtonProps } from './types';
import { backToTopLabel } from './constants';

const BackToTopButton = ({ className = '' }: BackToTopButtonProps) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className={`backToTop same-color ${className}`}
      data-testid="back-to-top"
      onClick={handleClick}
    >
      <Img className="dark-icon" src="/images/svg/back-arrow.svg" />
      <Img className="light-icon" src="/images/svg/back-arrow-dark.svg" />
      <span>{backToTopLabel}</span>
    </div>
  );
};

export default BackToTopButton;
